import getRequest from '../../../getRequest';

/**
 * Get all users from PRISM db.
 *
 * @returns {object}
 */
const getAllUserGroup = (search) => {
  const endpoint = `/users-management/get-all-user-group?search=${search === undefined ? '' : search}`;

  return new Promise((resolve, reject) => {
    getRequest(endpoint, 'Get All User Group')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

export default getAllUserGroup;
